import '../../assets/css/pages/ITheadquarters/prohibited-item.css';
import ProhibitedItem from '../../components/layout/ITHeadquarters/prohibitedItem';

const ProhibitedItemPage = () => {
    return <ProhibitedItem />;
};
export default ProhibitedItemPage;
